import { DebugLogger } from "@ng-mw/shared-react-components"
import { NetworkFirstApiCache } from "@app/service-worker/constants"

export const deleteUserServiceWorkerCache = async () => {
    if (typeof caches === "undefined" || typeof caches.keys !== "function") {
        return
    }

    await caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
            if (cacheName.includes(NetworkFirstApiCache)) {
                caches.delete(cacheName)

                DebugLogger.log(`deleted service worker cache: ${cacheName}`)
            }
        })
    })
}

export default deleteUserServiceWorkerCache
